/**
 * Style cell Xuất khẩu
 */
const StyleCell = {
  Normal: 0,
  String: 1,
  Number: 2,
  Percent: 3,
  Formula: 4, // Dòng công thức
  Header: 5,
  Date: 6,
  FileName: 7, // Dòng tên chính có kích thước lớn hơn cả
  Serial: 8, // Số thứ tự
};

export default StyleCell;
